import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { formatDateTime, HeaderSection } from './OrderComponent';
import Layout from '../Layout';
import { OrderApi } from '../../app/api/order.api';


export function DeliveredOrder () 
{
  const order = OrderApi();
  const [date, setDate] = useState("");
  const [ref, setRef] = useState("ORD-");
  const [filteredData, setFilteredData] = useState([]);
  
  
  const fetchData = async () => { 
    const {data} = await order.findAllBystatus('delivered');
    return data.data; 
  }
  const { isLoading, data=[], error } = useQuery({  queryKey: ["deliveredOrders"], queryFn: fetchData });
    
  useEffect(() => {
      
      if (!Array.isArray(data)) return;
      let filtered = data;
      
      if (date) filtered = filtered.filter(item => item.updatedAt?.toLowerCase().startsWith(date.toLowerCase()) );
      if (ref) filtered = filtered.filter(item => item.ref?.toLowerCase().startsWith(ref.toLowerCase()) );
  
      setFilteredData(filtered);
      
  }, [data, date, ref]); 
  

  return (

    <Layout activeMenu={1}>
  
      <div className='container-fluid'>
        <div className='row justify-content-center pt-4'>
          <div className='col-md-11'>
                
            <div className='row' >
              <HeaderSection active={2} />
            </div>

            <div className='row' >
              {/* Header background */}
              <div className="card border rounded-top-0 px-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center py-3 gap-2">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-funnel text-muted"></i>
                    <span className="text-secondary"> Filtre : { filteredData.length } effectif(s) </span>
                  </div>
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <input type="month" name="month" className="border px-3 py-1 text-secondary" onChange={ e => setDate(e.target.value) } />
                    {/* SEARCH BAR */}
                    <div className="d-flex align-items-center">
                      <input type="search" className="w-100 px-3 py-1 border text-secondary" placeholder="Rechercher une commande..." name="ref" value={ref} onChange={ e => setRef(e.target.value) } />
                      <span className="border py-1 px-2"> <i className="bi bi-search text-muted"></i> </span>                 
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row mt-4 mb-5'> 

              {/* Loading */}
              {isLoading && (
                <div className="d-flex flex-column align-items-center gap-3">
                  <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                  <p className="text-secondary"> Chargement en cours... </p>
                </div>
              )}
              
              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}
              
              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (
        
                filteredData.map( ( item, index ) => (

                    <div className="border bg-white text-secondary rounded-3 mt-4" key={index}>
                      <div className={`badge-corner last text-light`}> </div>
                      <div className="d-flex flex-column border-bottom px-4 py-3 mt-2">
                        <div className="d-flex align-items-center">    
                           <span className="text-secondary py-2 border px-3 bg-light h6"> 
                             <i className="bi bi-clock me-2"></i> Ref commande : 
                           </span>
                           <span className="text-secondary py-2 px-3 h6"> { item.ref } </span>
                        </div>  
                        <div className="d-flex gap-2 align-items-center border px-2 bg-light small mb-1">
                          <span className="text-secondary p-2"> Nom du client : </span>
                          <span className="text-secondary p-2">
                            { item.user.fname + " " + item.user.lname }
                          </span>
                        </div>
                        <div className="d-flex gap-2 align-items-center border px-2 bg-light small mb-1">
                          <span className="text-secondary p-2"> Tel du client : </span>
                          <span className="text-secondary p-2">
                             { item.user.phone }
                          </span>
                        </div>
                        <div className="d-flex gap-2 align-items-center border px-2 bg-light small mb-1">
                          <span className="text-secondary p-2"> Date : </span>
                          <span className="text-secondary p-2">
                            { formatDateTime( item.updatedAt) }
                          </span>
                        </div> 
                      </div>  
                      <div className="d-flex flex-column flex-lg-row gap-3 px-4 py-3">
                        <div className="d-flex">
                          <a className={`btn btn-sm d-flex align-items-center px-3 btn-green`} href={`/commande/${item.id}`}> 
                            Consulter <i className="bi bi-box-arrow-up-right ms-2"></i>
                          </a>
                        </div>
                        <div className="d-flex align-items-center border">    
                          <span className="text-secondary d-flex align-items-center px-3 bg-light fw-bold border-end"> 
                            <i className="bi bi-grid-fill me-2"></i> Montant total :  
                          </span>
                          <span className="text-secondary py-2 px-3"> { item.amount }  </span>
                          <span className="text-secondary py-2 px-3 bg-light border-start"> FCFA  </span>
                        </div>   
                      </div> 
                    </div>         
                    
                  ))
              )}  

              { /* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}

            </div>

          </div>   
        </div>
      </div>

    </Layout>

  );
        
}